
export const SET_VISIBLE_POSITION = 'SET_VISIBLE_POSITION';

export function setVisiblePosition(index) {return{ type: SET_VISIBLE_POSITION, payload: index}}
